.track {
  position: relative;
  width: 100%;
  height: 4px;
  overflow: hidden;
  border-radius: var(--radius-full);
  background: var(--color-surface-sunken);
}

.fill {
  position: absolute;
  inset: 0;
  transform-origin: left center;
  transition: transform var(--duration-slow) var(--ease-standard);
}

.accent {
  background: var(--color-accent);
}

.neutral {
  background: var(--color-text-muted);
}

.success {
  background: var(--color-success);
}

.indeterminate {
  width: 40%;
  animation: slide 1.4s ease-in-out infinite;
}

@keyframes slide {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(250%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .indeterminate {
    width: 100%;
    opacity: 0.5;
    animation: none;
  }
}
